export default input => {
  let hash = 0
  const len = input.length
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    // eslint-disable-next-line no-bitwise
    hash = ((hash << 5) - hash) + input.charCodeAt(i)
    // eslint-disable-next-line no-bitwise
    hash |= 0 // to 32bit integer
  }
  return hash
}
